import { render, staticRenderFns } from "./tasksPage.vue?vue&type=template&id=4d84a9b7&scoped=true"
import script from "./tasksPage.vue?vue&type=script&lang=js"
export * from "./tasksPage.vue?vue&type=script&lang=js"
import style0 from "./tasksPage.vue?vue&type=style&index=0&id=4d84a9b7&prod&scoped=true&lang=css"
import style1 from "./tasksPage.vue?vue&type=style&index=1&id=4d84a9b7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d84a9b7",
  null
  
)

export default component.exports